import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import AnalyticsTracking from '@/analytics/tracking';
import AuthService from '@/services/auth';
import LoginPage from '@/pages/LoginPage/LoginPage';
import FloorplansPage from '@/pages/FloorplansPage/FloorplansPage';
import FloorplanList from '@/pages/FloorplansPage/FloorplanList/FloorplanList';
import FloorplanDetail from '@/pages/FloorplansPage/FloorplanDetail/FloorplanDetail';
import FloorplanCompare from '@/pages/FloorplansPage/FloorplanCompare/FloorplanCompare';
import NeighbourhoodLanding from '@/pages/NeighbourhoodPage/NeighbourhoodLanding';
import NeighbourhoodPage from '@/pages/NeighbourhoodPage/NeighbourhoodMap/NeighbourhoodPage';
import NeighbourhoodHeart from '@/pages/NeighbourhoodPage/NeighbourhoodHeart/NeighbourhoodHeart';
import BuilderPage from '@/pages/BuilderPage/BuilderPage';
import AmenitiesPage from '@/pages/AmenitiesPage/AmenitiesPage';
import AmenitiesGalleryPage from '@/pages/AmenitiesPage/pages/AmenitiesGalleryPage';
import AmenitiesArchitecturePage from '@/pages/AmenitiesPage/pages/AmenitiesArchitecturePage';
import AmenitiesFeaturesPage from '@/pages/AmenitiesPage/pages/AmenitiesFeaturesPage';
import AmenitiesSuitesPage from '@/pages/AmenitiesPage/pages/AmenitiesSuitesPage';
import VideoPage from '@/pages/VideoPage/VideoPage';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: (window.location.href.indexOf('blacklineapp.com') > -1) ? '/queens-marque/' : '/',
  routes: [{
    path: '/',
    component: FloorplansPage,
    children: [
      {
        name: 'FloorplanList',
        path: '/',
        component: FloorplanList
      },
      {
        name: 'FloorplanDetail',
        path: 'floorplan/:id',
        component: FloorplanDetail
      },
      {
        name: 'FloorplanCompare',
        path: 'compare',
        component: FloorplanCompare
      },
      {
        name: 'FloorplanFavourites',
        path: 'favourites',
        component: FloorplanList
      }
    ]
  },
  {
    name: 'Login',
    path: '/login',
    component: LoginPage
  },
  {
    // name: 'Neighbourhood',
    path: '/neighbourhood',
    component: NeighbourhoodLanding,
    children: [{
      name: 'Neighbourhood',
      path: '/',
      component: NeighbourhoodPage
    },
    {
      name: 'Heart',
      path: 'heart',
      component: NeighbourhoodHeart
    },
    {
      name: 'Video',
      path: 'video',
      component: VideoPage
    },
    ]
  },
  {
    name: 'Builder',
    path: '/builder',
    component: BuilderPage
  },
  {
    // name: 'Amenities',
    path: '/amenities',
    component: AmenitiesPage,
    children: [
      {
        name: 'Renderings',
        path: '/',
        component: AmenitiesGalleryPage
      },
      {
        name: 'SuiteDetails',
        path: '/amenities/suites/:page',
        component: AmenitiesSuitesPage
      },
      {
        name: 'Features',
        path: '/amenities/features',
        component: AmenitiesFeaturesPage
      },
      {
        name: 'Architecture',
        path: '/amenities/architecture',
        component: AmenitiesArchitecturePage
      },
    ]
  }, {
    name: 'Video',
    path: '/video',
    component: VideoPage
  }
  ],
  scrollBehavior(to, from) {
    return new Promise((resolve) => {
      setTimeout(() => {
        if (to.name === 'FloorplanDetail' && from.name === 'FloorplanList') {
          resolve({
            x: 0,
            y: 0
          });
        }
        resolve();
      }, 300);
    });
  }
});

router.beforeEach((to, from, next) => {
  if (!store.state.project.forPublic) {
    const localUser = AuthService.getLocalUser();
    if (localUser) {
      if (AuthService.checkLocalUser(localUser)) {
        store.commit('user/setUserToken', localUser.token);
        store.commit('user/setAgent', localUser.agent);
        AnalyticsTracking.setUser(localUser.agent.email, localUser.agent.name);
        if (to.path !== '/login') {
          next();
        } else {
          next({
            path: '/'
          });
        }
        return;
      }
      AuthService.removeLocalUser();
    }
    if (to.path === '/login') {
      next();
    } else {
      next({
        path: '/login'
      });
    }
  } else if (to.path === '/login') {
    next({
      path: '/'
    });
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js